import { isMouseOutsideHotspot } from './hotspot';
export function getNumberOfHoverOutLevels(event, hoverStack, scrollPos) {
    var numberOfLevels = 0;
    for (var i = hoverStack.length - 1; i >= 0; i -= 1) {
        if (isMouseOutsideHotspot(event, hoverStack[i], scrollPos)) {
            numberOfLevels += 1;
        }
        else {
            break;
        }
    }
    return numberOfLevels;
}
